// LOTE UX-1 — contexto da oportunidade "em foco" (DealDetalhe aberta).
// Permite que o botão "+" da barra inferior, quando pressionado dentro
// de uma oportunidade, abra a janela Registrar atividade já preenchida
// com cliente_id/cliente_nome/deal_id da própria oportunidade.
import { createContext, useContext, useState, useCallback } from "react";

const CurrentDealContext = createContext(null);

export function CurrentDealProvider({ children }) {
  const [deal, setDeal] = useState(null);
  const clear = useCallback(() => setDeal(null), []);
  return (
    <CurrentDealContext.Provider value={{ deal, setDeal, clear }}>
      {children}
    </CurrentDealContext.Provider>
  );
}

export function useCurrentDeal() {
  const ctx = useContext(CurrentDealContext);
  return ctx || { deal: null, setDeal: () => {}, clear: () => {} };
}
